<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";

    export default {
        name: "PaymentPlatform",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                ],
                permission:{
                    add: 'paymentPlatform:add',
                    update: 'paymentPlatform:update',
                    delete: 'paymentPlatform:delete',
                    deleteBatch: 'paymentPlatform:deleteBatch'
                },
                url: {
                    get: '/paymentPlatform/listByCondition',
                    add: '/paymentPlatform/add',
                    update: '/paymentPlatform/update',
                    delete: '/paymentPlatform/delete/',
                    delete_batch: '/paymentPlatform/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                },{
                    field: 'name',
                    label: '名称',
                    show: true,
                    width: '',
                }, {
                    field: 'pid',
                    label: 'PID',
                    show: true,
                    width: '',
                }, {
                    field: 'secret',
                    label: '秘钥',
                    show: true,
                    width: '',
                }, {
                    field: 'payUrl',
                    label: '下单地址',
                    show: true,
                    width: '',
                }, {
                    field: 'searchUrl',
                    label: '查询地址',
                    show: true,
                    width: '',
                }, {
                    field: 'notifyUrl',
                    label: '回调地址',
                    show: true,
                    width: '',
                }, {
                    field: 'className',
                    label: '执行类名',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加支付平台',
                    updateTitle: '修改支付平台',
                    model: [{
                        field: 'name',
                        label: '平台名称：',
                        type: 'input',
                        placeholder: '平台名称',
                        rules:[{message: '请输入平台名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'payUrl',
                        label: '下单地址：',
                        type: 'input',
                        placeholder: '下单地址',
                        rules:[{message: '请输入下单地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'searchUrl',
                        label: '查询地址：',
                        type: 'input',
                        placeholder: '查询地址',
                        rules:[{message: '请输入查询地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'notifyUrl',
                        label: '回调地址：',
                        type: 'input',
                        placeholder: '回调地址',
                        rules:[{message: '请输入回调地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'className',
                        label: '执行的类名：',
                        type: 'input',
                        placeholder: '执行的类名',
                        rules:[{message: '请输入执行的类名', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
